import React from 'react';
import { Link } from 'react-router-dom';
import { Patient } from '../utils/mockData';

interface PatientTileProps {
  patient: Patient;
}

const PatientTile: React.FC<PatientTileProps> = ({ patient }) => {
  const getPainLevelColor = (level: number) => {
    if (level <= 3) return 'bg-green-100 border-green-300';
    if (level <= 6) return 'bg-yellow-100 border-yellow-300';
    return 'bg-red-100 border-red-300';
  };

  const getInjuryIcon = (injury: string) => {
    // This is a placeholder. You should replace with actual icons or small body diagrams.
    switch (injury.toLowerCase()) {
      case 'lower back pain': return '🦴';
      case 'neck strain': return '🧠';
      case 'sciatica': return '🦵';
      case 'shoulder pain': return '💪';
      case 'knee pain': return '🦵';
      case 'carpal tunnel': return '✋';
      case 'hip pain': return '🦴';
      case 'plantar fasciitis': return '🦶';
      case 'tennis elbow': return '💪';
      case 'whiplash': return '🧠';
      default: return '👤';
    }
  };

  return (
    <Link to={`/patient/${patient.id}`} className="block">
      <div className={`p-4 rounded-lg shadow-md border ${getPainLevelColor(patient.painLevel)}`}>
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-lg font-semibold">{patient.name}</h3>
          <span className="text-2xl" title={patient.injury}>{getInjuryIcon(patient.injury)}</span>
        </div>
        <p className="text-sm text-gray-600">Age: {patient.age} | {patient.gender}</p>
        <p className="text-sm text-gray-600">{patient.location}</p>
        <p className="text-sm font-medium mt-2">{patient.injury}</p>
        <p className="text-sm font-bold mt-1">Pain Level: {patient.painLevel}/10</p>
      </div>
    </Link>
  );
};

export default PatientTile;